import React from "react"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { sanitize } from "../../../formatters/Sanitize"

export default function WellnessDbsInstruction() {
  const { t } = useTranslation()

  return <>
    <Row>
      <Col md={8} lg={9}>
        <ul className="shipping" dangerouslySetInnerHTML={{ __html: sanitize(t("registration.shipping.instruction.wellnessdbs1")) }} />
      </Col>
      <Col md={3} lg={2} className="mt-1 text-center">
        <img src={`${process.env.PUBLIC_URL}/images/WDBS_Ship1.png`} alt="" width="200" />
      </Col>
    </Row>
    <Row>
      <Col md={8} lg={9} className="mt-3">
        <ul className="shipping" dangerouslySetInnerHTML={{ __html: sanitize(t("registration.shipping.instruction.wellnessdbs2")) }} />
      </Col>
      <Col md={3} lg={2} className="mt-3 text-center">
        <img src={`${process.env.PUBLIC_URL}/images/WDBS_Ship2.png`} alt="" width="200" />
      </Col>
    </Row>
  </>
}
